import { createAction } from '@reduxjs/toolkit';

export const FILTER_CALL_HISTORY_ACTION_TYPE = 'saga/filterCallHistory';
export const filterCallHistoryAction = createAction(FILTER_CALL_HISTORY_ACTION_TYPE);
